import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {EsriExpand, EsriReactiveUtils} from '../../../config/esri.module';
import { MainMapService } from '../../../shared/service/main-map.service';
import { WidgetNotifyService } from '../../../shared/service/widget-notify.service';
import { User } from '../../model/user.model';
import { UserService } from '../../service/user.service';
import { PortalAuthService } from 'portal-auth';
import {BaseWidget} from "../../../component/tools/base-widget/base-widget";

@Component({
    selector: 'user-component',
    templateUrl: './user.component.html',
    styleUrls: ['user.component.scss'],
    standalone: false
})
export class UserComponent extends BaseWidget implements OnInit {
  // Reference to DOM element of this component
  @ViewChild('userComponentRef', { static: true }) userComponentRef: ElementRef;
  // The logged user
  public user: User;

  constructor(
    public mainMapService: MainMapService,
    private userService: UserService,
    public widgetNotifyService: WidgetNotifyService,
    private translate: TranslateService,
    private readonly portalAuthService: PortalAuthService
  ) {
    super(mainMapService, widgetNotifyService);
  }

  ngOnInit() {
    // set the correct user to the component for view
    this.user = this.userService.user;
    // get the map view
    const mapView: __esri.MapView = this.mainMapService.mapView;
    this.handleExpandWidget(mapView);
  }

  /**
   * @function logout
   * @description Logout web-app from WAF with predefined URL and redirect to logout-page
   */
  public logout(): void {
    this.portalAuthService.logout();
  }

  private handleExpandWidget(mapView: __esri.MapView) {
    this.expandWidget = new EsriExpand(this.expandInstanceProperties(mapView));
    this.mainMapService.registerWidget(this.expandWidget);
    // add widget to the main map
    mapView.ui.add(this.expandWidget, 'top-right');
    // Open this widget, will close other widgets
    EsriReactiveUtils.watch(
      () => this.expandWidget.expanded,
      () => {
        if (this.expandWidget.expanded) {
          this.mainMapService.closeOtherWidgets(this.expandWidget);
          this.hiddenContainer = false;
        }
      }
    );
    // expand widget on create
    if (this.expandOnInit) {
      this.expandWidget.expand();
    }
  }

  private expandInstanceProperties(mapView: __esri.MapView): __esri.ExpandProperties {
    return {
      view: mapView,
      id: 'UserComponent',
      content: this.userComponentRef.nativeElement,
      expandIcon: 'user',
      collapseTooltip: this.translate.instant('WIDGET.USER.TOOLTIP'),
      expandTooltip: this.translate.instant('WIDGET.USER.TOOLTIP'),
    };
  }

}
